import Activity from '@/pages/protected/Activity';
import Announcements from '@/pages/protected/Announcements';
import AssistantChatPage from '@/pages/protected/AssistantChat';
import Attendance from '@/pages/protected/Attendance';
import CalendarV1Page from '@/pages/protected/CalendarV1';
import CreateAnnouncements from '@/pages/protected/CreateAnnouncements';
import CreateInventory from '@/pages/protected/CreateInventory';
import CreateInventoryCategory from '@/pages/protected/CreateInventoryCategory';
import CreateService from '@/pages/protected/CreateService';
import CreateServiceDivision from '@/pages/protected/CreateServiceDivision';
import CreateServiceGroup from '@/pages/protected/CreateServiceGroup';
import CreateServicesCategory from '@/pages/protected/CreateServicesCategory';
import DashboardPage from '@/pages/protected/Dashboard';
import EditAnnouncements from '@/pages/protected/EditAnnouncements';
import EditInventory from '@/pages/protected/EditInventory';
import EditInventoryCategory from '@/pages/protected/EditInventoryCategory';
import EditService from '@/pages/protected/EditService';
import EditServiceDivision from '@/pages/protected/EditServiceDivision';
import EditServiceGroup from '@/pages/protected/EditServiceGroup';
import EditServiceLanding from '@/pages/protected/EditServiceLanding';
import EditServicesCategory from '@/pages/protected/EditServicesCategory';
import InventoryPage from '@/pages/protected/Inventory';
import InventoryCategoriesPage from '@/pages/protected/InventoryCategories';
import NewBookingPage from '@/pages/protected/NewBooking';
import PaymentsPage from '@/pages/protected/Payments';
import QuickActionsPage from '@/pages/protected/QuickActions';
import Reservations from '@/pages/protected/Reservations';
import ReservationDetail from '@/pages/protected/Reservations/ReservationDetail';
import Sales from '@/pages/protected/Sales';
import SaleDetail from '@/pages/protected/Sales/SaleDetail';
import ServiceDetailPage from '@/pages/protected/ServiceDetail';
import ServicesPage from '@/pages/protected/Services';
import ServicesCategoriesPage from '@/pages/protected/ServicesCategories';
import SettingsPage from '@/pages/protected/Settings';
import StudentView from '@/pages/protected/StudentView';
import StudentViewEdit from '@/pages/protected/StudentViewEdit';
import Users from '@/pages/protected/Users/index';
import UserDetail from '@/pages/protected/Users/UserDetail';
import type { RouteObject } from 'react-router-dom';

export const PROTECTED_ROUTES: RouteObject[] = [
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/calendar', element: <CalendarV1Page /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/activity', element: <Activity /> },
  { path: '/activity/students/:id', element: <StudentView /> },
  { path: '/activity/students/:id/edit', element: <StudentViewEdit /> }, // TODO: Remove this route in next sprint 32/33
  { path: '/attendance', element: <Attendance /> },
  { path: '/services/categories', element: <ServicesCategoriesPage /> },
  { path: '/services/categories/create', element: <CreateServicesCategory /> },
  { path: '/services/categories/edit/:id', element: <EditServicesCategory /> },
  { path: '/services/create', element: <CreateService /> },
  { path: '/services/:id', element: <ServiceDetailPage /> },
  { path: '/services/:id/edit', element: <EditService /> },
  { path: '/services/:id/edit-landing', element: <EditServiceLanding /> },
  { path: '/services/:id/create-division', element: <CreateServiceDivision /> },
  { path: '/services/:id/create-group', element: <CreateServiceGroup /> },
  {
    path: '/services/:id/edit-division/:divisionId',
    element: <EditServiceDivision />
  },
  {
    path: '/services/:id/edit-group/:groupId',
    element: <EditServiceGroup />
  },
  { path: '/inventory', element: <InventoryPage /> },
  { path: '/inventory/create', element: <CreateInventory /> },
  { path: '/inventory/edit/:id', element: <EditInventory /> },
  { path: '/inventory/categories', element: <InventoryCategoriesPage /> },
  {
    path: '/inventory/categories/create',
    element: <CreateInventoryCategory />
  },
  {
    path: '/inventory/categories/edit/:id',
    element: <EditInventoryCategory />
  },
  { path: '/payments', element: <PaymentsPage /> },
  { path: '/settings', element: <SettingsPage /> },
  { path: '/new-booking', element: <NewBookingPage /> },
  { path: '/quick-actions', element: <QuickActionsPage /> },
  { path: '/announcements', element: <Announcements /> },
  { path: '/announcements/create', element: <CreateAnnouncements /> },
  { path: '/announcements/edit/:id', element: <EditAnnouncements /> },
  { path: '/messages', element: <AssistantChatPage /> },

  // Sales routes
  { path: '/sales', element: <Sales /> },
  { path: '/sales/:id', element: <SaleDetail /> },

  // Reservations routes
  { path: '/reservations', element: <Reservations /> },
  { path: '/reservations/:id', element: <ReservationDetail /> },

  // Users routes
  { path: '/users', element: <Users /> },
  { path: '/users/:id', element: <UserDetail /> },
  { path: '/users/:id/edit', element: <StudentViewEdit /> }
];
